import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@omilia/tooltip';

import './style.scss';

const TrashTooltip = ({ className, text, placement, onDelete }) => (
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/anchor-is-valid */
  <Tooltip content={text} placement={placement}>
    <a
      styleName="trash"
      className={className}
      data-test="trash"
      onClick={onDelete}
    >
      <i className="icon-recycle-bin" />
    </a>
  </Tooltip>
);

TrashTooltip.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  placement: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
};

TrashTooltip.defaultProps = {
  className: '',
  placement: 'left',
};

export default TrashTooltip;
